module.exports = {"pathContext":{"name":"CreateStockTransferRequestItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"requestedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-create-stock-transfer-request-item-input.json
// module id = 1406
// module chunks = 221424569729900